export function traducirLabel(id) {
    const list = localStorage.getItem("etiquetas");
    const etiquetas = (list === null || list === "undefined") ? [] : JSON.parse(list);
    return etiquetas.find(a => a.clave === `lbl_pantalla_${('000' + id.toString()).substring(('000' + id.toString()).length - 3, ('000' + id.toString()).length)}`)?.descripcion ?? 'Label';
};

export function traducirMessage(id) {
    const list = localStorage.getItem("etiquetas");
    const etiquetas = (list === null || list === "undefined") ? [] : JSON.parse(list);
    return etiquetas.find(a => a.clave === `msg_pantalla_${('000' + id.toString()).substring(('000' + id.toString()).length - 3, ('000' + id.toString()).length)}`)?.descripcion ?? 'Message';
};

export function traducirButton(id) {
    const list = localStorage.getItem("etiquetas");
    const etiquetas = (list === null || list === "undefined") ? [] : JSON.parse(list);
    return etiquetas.find(a => a.clave === `btn_pantalla_${('000' + id.toString()).substring(('000' + id.toString()).length - 3, ('000' + id.toString()).length)}`)?.descripcion ?? 'Button';
};
